import { createShiftJsonClient } from '../http/shift-json-client';
import type { ShiftGovernancePatch, ShiftAvailabilityLockPatch } from 'shared-models';
import type {
  ShiftAvailabilityPeriod,
  ShiftAvailabilityUpdateInput,
  ShiftAvailabilityWeek,
  ShiftWeeklyNoteMutationInput,
} from '../../models/availability.types';

const requestJson = createShiftJsonClient('אין תקשורת לשרת. ודאו שה-backend רץ על http://localhost:5000.');

class ShiftAvailabilityService {
  async patchGovernance(payload: ShiftGovernancePatch): Promise<void> {
    return requestJson('/shift/availability/settings', { method: 'PATCH', body: JSON.stringify(payload) });
  }

  async patchWeekLock(weekStart: string, payload: ShiftAvailabilityLockPatch): Promise<void> {
    return requestJson(`/shift/availability/locks?weekStart=${encodeURIComponent(weekStart)}`, { method: 'PATCH', body: JSON.stringify(payload) });
  }

  async getWeek(weekStart: string): Promise<ShiftAvailabilityWeek> {
    return requestJson<ShiftAvailabilityWeek>(
      `/shift/availability?weekStart=${encodeURIComponent(weekStart)}`,
      {
        method: 'GET',
      },
    );
  }

  async updateDay(
    dateDay: string,
    payload: ShiftAvailabilityUpdateInput,
  ): Promise<ShiftAvailabilityPeriod & { dateDay: string }> {
    return requestJson<ShiftAvailabilityPeriod & { dateDay: string }>(
      `/shift/availability/${encodeURIComponent(dateDay)}`,
      {
        method: 'PATCH',
        body: JSON.stringify(payload),
      },
    );
  }

  async mutateWeeklyNotes(payload: ShiftWeeklyNoteMutationInput): Promise<void> {
    await requestJson<void>('/shift/availability/notes', {
      method: 'PATCH',
      body: JSON.stringify(payload),
    });
  }
}

export const shiftAvailabilityService = new ShiftAvailabilityService();
